import '../src/js/input-auto-select';
import ujs from '@rails/ujs';

ujs.start();
